// extracted by mini-css-extract-plugin
module.exports = {"SideMenu":"SideMenu_SideMenu__31NAD","MenuTitle":"SideMenu_MenuTitle__3HbIq","Open":"SideMenu_Open__3FgHJ","Close":"SideMenu_Close__1-09s"};